import { Page } from "@/models/page-models/Page";

export const SampleLoadingManifest: Page = {
  "path": "sample-loading-manifest/:sampleId",
  "name": "Sample Loading Manifest",
  "props": {
    "data": {
      "title": "Sample Loading Manifest",
      "printable": "fn(LOGICAL,fn(LOGICAL,{{fetchedData.sample.data.waybillNumber}},==,0),||,fn(NOT,fn(NOT,{{fetchedData.sample.data.waybillNumber}})))",
      "url": "sample-loading-manifest/:sampleId",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "custom_LoadingManifestDetails",
                  "variable": "fetchedData.sample.data",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.sample.data}}",
                  "config": {
                    "customerDetailsVariable": "fetchedData.customer.data",
                    "lmType": "sample"
                  }
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Lm Orders",
                  "disabled": "FALSE",
                  "showIf": "fn(LENGTH,{{fetchedData.lmArray}})",
                  "items": "fetchedData.lmArray",
                  "headers": [
                    {
                      "value": "slNo",
                      "text": "#"
                    },
                    {
                      "value": "productId",
                      "text": "Item #\\n# المنتج",
                      "type": "formula",
                      "formula": "{{fetchedData.selectedProduct.data._id}}"
                    },
                    {
                      "value": "order",
                      "text": "Order #\\n# حزمة",
                      "type": "formula",
                      "formula": "N/A"
                    },
                    {
                      "value": "description",
                      "text": "Description\\nالتفاصيل",
                      "type": "formula",
                      "formula": "{{fetchedData.selectedProduct.data.alias}}"
                    },
                    {
                      "value": "__item.quantityA",
                      "text": "Quantity A\\nA الكمية",
                      "type": "formula",
                      "formula": "fn(CONCAT,fn(HELPER_FN,convertSellingUnitQuantity,{{fetchedData.sample.data.quantity}},{{fetchedData.selectedProduct.data}},{{fetchedData.selectedProduct.data.packingMode.0.unit1}},{{fetchedData.sample.data.unit}}), ,{{fetchedData.selectedProduct.data.packingMode.0.unit1}})"

                    },
                    {
                      "value": "__item.quantityB",
                      "text": "Quantity B\\nB الكمية",
                      "type": "formula",
                      "formula": "fn(CONCAT,fn(HELPER_FN,convertSellingUnitQuantity,{{fetchedData.sample.data.quantity}},{{fetchedData.selectedProduct.data}},{{fetchedData.selectedProduct.data.packingMode.0.unit2}},{{fetchedData.sample.data.unit}}), ,{{fetchedData.selectedProduct.data.packingMode.0.unit2}})"
                    },
                    {
                      "value": "__item.quantityC",
                      "text": "Quantity C\\nC الكمية",
                      "type": "formula",
                      "formula": "fn(CONDITIONAL,fn(LOGICAL,fn(LENGTH,{{fetchedData.selectedProduct.data.packingMode}}),>,1),fn(CONCAT,fn(HELPER_FN,convertSellingUnitQuantity,{{fetchedData.sample.data.quantity}},{{fetchedData.selectedProduct.data}},{{fetchedData.selectedProduct.data.packingMode.1.unit2}},{{fetchedData.sample.data.unit}}), ,{{fetchedData.selectedProduct.data.packingMode.1.unit2}}),fn(CONCAT,N/A))"
                    }
                  ],
                  "tableType": "static",
                  "showActions": false,
                  "fontSize": "0.75rem;"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "custom_LoadingManifestShippingDetails",
                  "variable": "fetchedData.shippingDetails",
                  "label": "Shipping Details",
                  "config": {
                    "deliveryAddressRefVariable": "deliverTo"
                  }
                }
              ]
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Print",
                  "buttonType": "print",
                  "disabled": "FALSE",
                  "showIf": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.loadingManifestData.data.status}},'),!==,'Pending')",
                  "color": "primary"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "arabicTitle": "بيان التحميل للعينة",
      "useMaxPageWidth": true,
      "printDocDate": "{{fetchedData.sample.data.createdAt}}"
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getSampleDetail",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/sample/detail?id={{__params.sampleId}}",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.sample"
        },
        "name": "getSampleDetail"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "redirectToSampleEdit",
          "type": "fnRedirect",
          "arg1Key": "redirectUrl",
          "arg1Value": "/sample/{{fetchedData.sample.data._id}}"
        },
        "name": "redirectToSampleEdit",
        "executeIf": "fn(NOT,fn(LOGICAL,fn(LOGICAL,{{fetchedData.sample.data.waybillNumber}},==,0),||,fn(NOT,fn(NOT,{{fetchedData.sample.data.waybillNumber}}))))"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getProductData",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/product/detail?id={{fetchedData.sample.data.product._id}}",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.selectedProduct"
        },
        "name": "getProductData"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
        "name": "getCustomerData",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/customers/{{fetchedData.sample.data.customer._id}}",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.customer"
      },
        "name": "getCustomerData"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "pushLmArray",
          "type": "fnPushToArray",
          "arg1Key": "sourceVariable",
          "arg1Value": "fetchedData.sample.data",
          "arg2Key": "destinationVariable",
          "arg2Value": "fetchedData.lmArray",
          "arg3Key": "sourceTransformationFn",
          "arg3Value": "getResolvedSampleData"
        },
        "name": "pushLmArray"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "copyShippingDetails",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getShippingDetails",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.shippingDetails"
        },
        "name": "copyShippingDetails"
      }
    ],
    "functions": [
      {
        "name": "getResolvedSampleData",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "slNo": "1/1"
        },
        "staticObject": true
      },
      {
        "name": "getShippingDetails",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "deliverTo": "{{fetchedData.sample.data.deliverTo}}",
          "createdAt": "{{fetchedData.sample.data.dispatchedAt}}",
          "typeOfDelivery": "{{fetchedData.sample.data.shippingCompany}}",
          "trackingNo": "{{fetchedData.sample.data.waybillNumber}}"
        },
        "useFormula": true,
      }
    ]
  },
  "forRole": "SALES_MANAGER,SALES_ACCOUNT_EXECUTIVE,GENERAL_MANAGER,QA_MANAGER,QA_TECHNICAL_EXECUTIVE,QA_QUALITY_EXECUTIVE",
  "visible": false
}